import { BaseModal } from 'ui/BaseModal';

export const PayBaseModal = BaseModal;
